import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { TeamInvitePage } from "./-TeamInvitePage"

export const Route = createFileRoute("/team/invite")({
  validateSearch: z.object({ token: z.string().catch("") }),
  component: TeamInvitePage,
})
